import { history } from '../routers/AppRouter';
import axios from 'axios';
import paths from '../helpers/paths';
import { setUserDetails, setToken, getToken, deleteToken, deleteUserDetails } from '../helpers/auth';


// const loginUrl ='http://localhost:3000/api/v1/auth/login';
// const signupUrl ='http://localhost:3000/api/v1/auth/signup';

const loginUrl ='https://coozallbackend.herokuapp.com/api/v1/auth/login';
const signupUrl ='https://coozallbackend.herokuapp.com/api/v1/auth/signup';

export const setUser = (userDetails) => (
    {
      type: 'SET_USER',
      userDetails
    }
  )
  
  export const setLoginState = (loginState) => (   
    {
      type: 'SET_LOGIN_STATE',
      loginState
    }
  )

  export const setLoginErrorMessage = (loginErrorMessage) => (   
    {
      type: 'LOGIN_ERROR_MESSAGE',
      loginErrorMessage,
    }    
  )
  
  export const setSignupErrorMessage = (signupErrorMessage) => (   
    {
      type: 'SET_SIGNUP_ERROR',
      signupErrorMessage,
    }    
  )
  
  export const setSignupButtonState = (signupButtonState) => (   
    {
      type: 'SET_SIGNUP_BUTTON',
      signupButtonState,
    }    
  )
  
  export const setLoginButtonState = (loginButtonState) => (   
    {
      type: 'SET_LOGIN_BUTTON',
      loginButtonState,
    }    
  )

  export const setSignupProcessing = (signupProcessing) => (   
    {
      type: 'SET_SIGNUP_PROCESSING',
      signupProcessing,
    }    
  )
  
  export const signUp = (firstName, lastName, email, password, passwordAgain, phoneNo) => dispatch => {
    dispatch(setSignupProcessing('Signing Up..'))
    dispatch(setSignupButtonState(true))
    return axios.post(signupUrl, {
      firstName,
      lastName,
      email,
      password,
      passwordAgain,
      phoneNo,
    })
    .then(({data}) => {
      if(200 <= data.status  <= 299){
        dispatch(setSignupProcessing(undefined))
        // dispatch(setSignupError('Successfully signed up. Proceed to login.'));
        dispatch(setSignupButtonState(false))
        dispatch(setSignupErrorMessage(``));
        history.push(paths.login);
      }else if( 400 <= data.status <= 599){
        dispatch(setSignupErrorMessage(`${data.error}`));
        dispatch(setSignupButtonState(false));
      }else{
        dispatch(setSignupErrorMessage('An error occurred while signinig up'));
        dispatch(setSignupButtonState(false));
      }
    }).catch(error => {
      dispatch(setSignupProcessing(undefined));
      dispatch(setSignupButtonState(false));
      dispatch(setSignupErrorMessage(!!error.response ? error.response.data.error : 'An error occured. Please ensure that your internet connection is stabe.'));
    })
  };
  
  export const login = (email, password) => dispatch => {
    dispatch(setLoginState('LOGGING IN..'));
    dispatch(setLoginButtonState(true))
    return axios.post(loginUrl, {
     email,
     password,
  })
    .then(({data}) => {
      if(data){
        setToken(data.userDetails.token);
        dispatch(setUser(data.userDetails));
        setUserDetails(JSON.stringify(data.userDetails));    
        dispatch(setLoginState('STATE_LOGGED_IN'));
        dispatch(setLoginButtonState(false));
        dispatch(setLoginErrorMessage(``)); 
        history.push(paths.dashboard);      
      }else{
        dispatch(setLoginState('STATE_LOGIN_FAILED'));
        dispatch(setLoginErrorMessage('Network error'));   
      }   
   })
    .catch(error => {
      dispatch(setLoginState('STATE_LOGIN_FAILED'));
      dispatch(setLoginErrorMessage(error.response.data.error)); 
      dispatch(setLoginButtonState(false));
    });
  };
  
  
  export const logout = () => dispatch => {
    deleteToken();
    deleteUserDetails();    
    dispatch(setLoginState('STATE_LOGGED_OUT'));
    dispatch(setLoginErrorMessage(``));
    dispatch(setSignupErrorMessage(``));
    history.push(paths.login);
  }
